async function getSubs(subscriptionRepository) {
    return await subscriptionRepository.getSubscriptions()
}

async function getSubsV6(subscriptionRepository, euro) {
    return await subscriptionRepository.getSubscriptionsV6(euro)
}

export {getSubs, getSubsV6}
